import { graphql } from '@/gql';
import { mutationExecute } from '@/Utils/graphqlAPI';

export const sendContactCardSms = async ({ callerId, phoneNumber }: { callerId: string; phoneNumber?: string }) => {
  const response = await mutationExecute({
    variables: {
      callerId,
      phoneNumber,
    },
    mutation: graphql(`
      mutation SendContactCardSms($callerId: String!, $phoneNumber: String) {
        sendContactCardSms(callerId: $callerId, phoneNumber: $phoneNumber)
      }
    `),
  });

  return response.data?.sendContactCardSms ?? false;
};
